import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';

import Loading from 'components/Loading';
import ActivatedPlanCard from 'components/ActivatedPlanCard';
import { GET_ORDER } from 'queries/shop';

export default function ActivatedPlan() {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const { t } = useTranslation();
  const { data, loading } = useQuery(GET_ORDER, {
    variables: { sessionId },
    skip: !sessionId,
  });

  if (loading || !sessionId) {
    return <Loading size="xl" />;
  }

  const order = data?.order;

  if (!order) {
    throw new Error();
  }

  return (
    <>
      <div className="mb-8">
        <div className="text-center">
          <h1 className="mb-4">
            {order.status !== 'PAID' ? t('payment_success.title_2') : t('payment_success.title')}
          </h1>
          <p className="text-[#B0B0B3]">
            {order.status !== 'PAID' ? t('payment_success.text4') : t('payment_success.text1')}
          </p>
        </div>
      </div>
      <ActivatedPlanCard
        product={order.product}
        serialNumber={order.device.serialNumber}
        subscription={order.subscription}
      />
    </>
  )
}
